<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'branchSettings.addCustomVariable' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (submit)="submit()" class="branch-variable-form-dialog__form">
      <div class="branch-variable-form-dialog__source-field">
        <div class="branch-variable-form-dialog__source-label">
          {{ 'settings.settingSource' | translate }}
        </div>
        <mat-radio-group
          formControlName="source"
          class="branch-variable-form-dialog__source-group"
          color="primary"
          (change)="sourceChanged($event.value)"
        >
          <mat-radio-button
            value="predefined"
            [disabled]="predefinedVariables.length === 0"
          >
            {{ 'settings.defaultEmployeeSettingSource' | translate }}
          </mat-radio-button>
          <mat-radio-button value="custom">
            {{ 'settings.customEmployeeSettingSource' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="branch-variable-form-dialog__field" *ngIf="isPredefinedSource">
        <mat-form-field appearance="outline">
          <mat-label>{{
            'settings.defaultEmployeeSetting' | translate
          }}</mat-label>
          <mat-select
            formControlName="predefinedName"
            (selectionChange)="predefinedVariableChanged($event.value)"
            [errorStateMatcher]="errorStateMatcher"
          >
            <mat-option
              *ngFor="let variable of predefinedVariables"
              [value]="variable.name"
            >
              {{ variable.label || variable.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('predefinedName')?.hasError('required')">
            {{ 'fieldRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        class="branch-variable-form-dialog__field"
        *ngIf="isPredefinedSource && form.controls.name.value"
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ 'settings.customField' | translate }}</mat-label>
          <input type="text" matInput formControlName="name" readonly />
        </mat-form-field>
      </div>

      <div
        class="branch-variable-form-dialog__field"
        *ngIf="isPredefinedSource && form.controls.label.value"
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ 'settings.customLabel' | translate }}</mat-label>
          <input type="text" matInput formControlName="label" readonly />
        </mat-form-field>
      </div>

            <div class="branch-variable-form-dialog__field">
        <mat-form-field appearance="outline" class="icon-select-field">
          <mat-label>{{ 'settings.variableIcon' | translate }}</mat-label>
          <mat-select formControlName="iconUrl">
            <mat-select-trigger>
              <span class="branch-variable-form-dialog__icon-trigger">
                @if (mediaFilePreview(form.controls.iconUrl.value); as preview) {
                  <span
                    class="branch-variable-form-dialog__icon-file"
                    aria-hidden="true"
                  >
                    <mat-icon>{{ preview.icon }}</mat-icon>
                    <span>{{ preview.label }}</span>
                  </span>
                } @else {
                  <img
                    [src]="iconSrc(form.controls.iconUrl.value)"
                    alt=""
                    class="branch-variable-form-dialog__icon-trigger-img"
                    width="22"
                    height="22"
                    loading="lazy"
                  />
                }
                {{ iconLabel(form.controls.iconUrl.value) }}
              </span>
            </mat-select-trigger>
            <mat-option
              *ngFor="let icon of hardcodedIcons"
              [value]="icon.value"
            >
              <span class="branch-variable-form-dialog__icon-option">
                <img
                  [src]="icon.preview"
                  alt=""
                  class="branch-variable-form-dialog__icon-option-img"
                  width="28"
                  height="28"
                />
                <span>{{ icon.label }}</span>
              </span>
            </mat-option>
            <mat-option
              *ngFor="let image of mediaImages"
              [value]="image.imageUrl"
            >
              <span class="branch-variable-form-dialog__icon-option">
                @if (mediaFilePreview(image.imageUrl); as preview) {
                  <span
                    class="branch-variable-form-dialog__icon-file"
                    aria-hidden="true"
                  >
                    <mat-icon>{{ preview.icon }}</mat-icon>
                    <span>{{ preview.label }}</span>
                  </span>
                } @else {
                  <img
                    [src]="image.imageUrl"
                    alt=""
                    class="branch-variable-form-dialog__icon-option-img"
                    width="28"
                    height="28"
                  />
                }
                <span>{{ image.name }}</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="branch-variable-form-dialog__field" *ngIf="isCustomSource">
        <mat-form-field appearance="outline">
          <mat-label translate>branchSettings.variableName</mat-label>
          <input type="text" matInput formControlName="name" [errorStateMatcher]="errorStateMatcher" />
          <mat-error *ngIf="form.get('name')?.hasError('required')">
            {{ 'fieldRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="form.get('name')?.hasError('pattern')">
            {{ 'branchSettings.variableNameNoSpaces' | translate }}
          </mat-error>
          <mat-error *ngIf="form.get('name')?.hasError('duplicateField')">
            {{ 'settings.duplicateFieldName' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="branch-variable-form-dialog__field" *ngIf="isCustomSource">
        <mat-form-field appearance="outline">
          <mat-label translate>settings.label</mat-label>
          <input type="text" matInput formControlName="label" [errorStateMatcher]="errorStateMatcher" />
          <mat-error *ngIf="form.get('label')?.hasError('required')">
            {{ 'fieldRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <app-progress-button
      label="save"
      (buttonClick)="submit()"
      [loading]="sendingRequest"
      color="primary"
    />
  </footer>
</div>
